export const LABEL_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  NEW: "new"
};

export const LABEL_TYPES = [
  LABEL_TYPE.SUCCESS,
  LABEL_TYPE.ERROR,
  LABEL_TYPE.INFO,
  LABEL_TYPE.WARNING,
  LABEL_TYPE.NEW
];
